import { render } from "./Publication.vue?vue&type=template&id=396eb094"
import script from "./Publication.vue?vue&type=script&lang=js"
export * from "./Publication.vue?vue&type=script&lang=js"
script.render = render

export default script